import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { StyledComponent } from '../../../types/styledComponent'

export const getDisabledStyle = (
  Control: StyledComponent,
  Label: StyledComponent,
  checked: boolean,
): SerializedStyles => css`
  ${Control} {
    box-shadow: none;

    ${checked
      ? css`
          color: ${Color.Grey300};
          background-color: ${Color.Grey100};
          border-color: transparent;
        `
      : css`
          border-color: ${Color.Grey200};
          background-color: ${Color.Grey100};
        `};
  }

  ${Label} {
    opacity: 0.5;
  }

  cursor: not-allowed;
`
